const BASE_URL = '/'
const AUTH = BASE_URL
const HOME = `${BASE_URL}home`

/**
 * Administração
 */
const ADMIN = `${BASE_URL}admin`
const ADMIN_USERS = `${ADMIN}/users`
const ADMIN_QUERIES = `${ADMIN}/queries`

/**
 * Documentos
 */
const DOCUMENTS = `${BASE_URL}documents`

/**
 * Contratos
 */
const DOCUMENTS_CONTRACTS = `${DOCUMENTS}/contracts`
const DOCUMENTS_CONTRACTS_DETAILS = `${DOCUMENTS_CONTRACTS}/:idContract`

/**
 * Movimentos
 */
const DOCUMENTS_MOVIMENTS = `${DOCUMENTS}/moviments`
const DOCUMENTS_MOVIMENTS_DETAILS = `${DOCUMENTS_MOVIMENTS}/:idMov`

/**
 * Medições
 */
const DOCUMENTS_MEASURES = `${DOCUMENTS}/measures`
const DOCUMENTS_MEASURES_EDIT = `${DOCUMENTS_MEASURES}/:id`

/**
 * Fornecedores
 */
const DOCUMENTS_SUPPLIERS = `${DOCUMENTS}/suppliers`
const DOCUMENTS_SUPPLIERS_DETAILS = `${DOCUMENTS_SUPPLIERS}/:cgccfo`

/**
 * Relatórios
 */
const REPORTS = `${BASE_URL}reports`
const REPORTS_MY_MEASURES = `${REPORTS}/my-measures`
const REPORTS_MANAGER_PENDENCES = `${REPORTS}/manager-pendences`
const REPORTS_FINANCIAL_PENDENCES = `${REPORTS}/financial-pendences`
const REPORTS_MEASURES_INVOICED = `${REPORTS}/measures-invoiced`

/**
 * Não Autorizado
 */
const UNAUTHORIZED = `${BASE_URL}not-authorized`

export default {
  BASE_URL,
  AUTH,
  HOME,
  ADMIN,
  ADMIN_USERS,
  ADMIN_QUERIES,
  DOCUMENTS,
  DOCUMENTS_CONTRACTS,
  DOCUMENTS_CONTRACTS_DETAILS,
  DOCUMENTS_MOVIMENTS,
  DOCUMENTS_MOVIMENTS_DETAILS,
  DOCUMENTS_MEASURES_EDIT,
  DOCUMENTS_SUPPLIERS,
  DOCUMENTS_SUPPLIERS_DETAILS,
  REPORTS,
  REPORTS_MY_MEASURES,
  REPORTS_MANAGER_PENDENCES,
  REPORTS_FINANCIAL_PENDENCES,
  REPORTS_MEASURES_INVOICED,
  UNAUTHORIZED,
}
